import { debounce } from 'lodash'
import { useCallback, useState, useEffect } from 'react'

const defaultGetValue = (e) => e.target.value

export const useSearch = ({
  time = 500, onSearch, min = 0, value = '', getValue = defaultGetValue,
}) => {
  const [inputValue, setInputValue] = useState(value)
  const doSearch = useCallback(
    debounce((e) => {
      // min is hard to handle. What happens when the user just deletes stuff ?
      const eventValue = getValue(e)
      if (eventValue.length < min) return
      onSearch(eventValue)
    }, time),
    [],
  )
  const handleSearch = useCallback((e) => {
    if (e.persist) {
      e.persist()
    }
    setInputValue(getValue(e))
    doSearch(e)
  }, [doSearch])
  // sync inputValue with external value changes
  useEffect(() => {
    setInputValue(value)
  }, [value])

  return {
    handleSearch,
    inputValue,
  }
}
